import React from 'react'
import {Fields} from 'modules/editor/Fields'
import {BasicInfoEditor,DicomDateFormatter} from 'modules/editor/BasicInfo'
import {Header} from 'modules/editor/Header'
import {Signatures} from 'modules/editor/Signatures'
import {TemplateSelector} from 'modules/template/TemplateSelector'
import {ManageTemplatesDialog} from 'modules/template/ManageTemplatesDialog'
import {Title} from 'modules/editor/Title'
import {EditorHeader} from 'modules/EditorHeader'
import {ViewerHeader} from 'modules/ViewerHeader'
import {Preview as PreviewWithoutFill} from 'modules/Preview'
import {formatDate} from 'components/datepicker'
import {en_US} from 'components/date.i18n/en_US'
import {dicomDateToDate} from 'lib'
import {KeyImagesPanel} from './modules/editor/keyImages/KeyImagesPanel'
import {KeyImages} from './modules/editor/KeyImages'
import {SendEmailDialog} from './modules/viewer/SendEmailDialog'
import {Fill} from 'react-slot-fill'

export {
  Fields,
  BasicInfoEditor,
  DicomDateFormatter,
  Header,
  Signatures,
  Title,
  EditorHeader,
  ViewerHeader,
  formatDate,
  en_US,
  dicomDateToDate,
  TemplateSelector,
  ManageTemplatesDialog,
  KeyImages,
  KeyImagesPanel,
  SendEmailDialog
}

export const Preview = (props) => <PreviewWithoutFill Fill={Fill} {...props} />


// WEBPACK FOOTER //
// ./~/report-components/src/index.js